import clsx from "clsx";
import { DrawerVariant, useDrawerContext } from "./drawer";

export interface DrawerItemProps extends Omit<
  React.HTMLAttributes<HTMLDivElement>,
  "title"
> {
  isActive?: boolean;
  icon?: React.FC<any>;
  title: React.ReactNode;
  nested?: boolean;
  variantOverride?: DrawerVariant;
}

export default function DrawerItem(props: Readonly<DrawerItemProps>) {
  const { open, variant, float } = useDrawerContext();

  const {
    className,
    isActive = false,
    icon: Icon,
    title,
    children,
    nested,
    variantOverride = variant,
    ...rest
  } = props;

  return (
    <div
      {...rest}
      className={clsx(
        "flex items-center py-2 rounded-xl",
        "transition-all duration-300",
        "select-none cursor-pointer",
        {
          "bg-primary text-white": isActive && variantOverride !== "colored",
          "bg-primary-light text-primary-dark":
            isActive && variantOverride === "colored",
          "text-primary-dark": !isActive && variantOverride === "light",
          "text-white": !isActive && variantOverride !== "light",
          "px-4 gap-3": open || float,
          "px-3 gap-1 justify-center": !open && !float,
          "hover:bg-primary/50": !isActive,
          "hover:bg-primary-light/25":
            !isActive && variantOverride === "colored",
          "flex-row": open || float,
          "flex-col": !open && !float,
        },
      )}
    >
      {!!Icon && (
        <div className="shrink-0">
          <Icon size="16" />
        </div>
      )}
      <div
        className={clsx("flex-1 truncate", {
          "text-xs": !open && !float,
        })}
      >
        {title}
      </div>
      {(open || float || nested) && (
        <>{!!children && <div className="shrink-0">{children}</div>}</>
      )}
    </div>
  );
}
